import * as React from 'react';
import {useState} from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Down, Up} from '../../common/btns';

const css = require('./item.css').default;

export default function ({item, onDel, onDup, onChange}: {
    item: item,
    onChange: (item: item) => void,
    onDel: () => void,
    onDup: () => void,
}) {
    const [show, setShow] = useState(false);
    const [mode, setMode] = useState<'less' | 'more'>(canLessMode(item) ? 'less' : 'more');

    function showCmds(props: any) {
        return (
        <Tooltip className={css.popupMenu} {...props}>
            <div className='item' onClick={() => {
                onDel();
                setShow(false);
            }}>刪除</div>
            <div className='item' onClick={() => {
                onDup();
                setShow(false);
            }}>複製</div>
        </Tooltip>);
    }

    return (
    <div className={css.item}>
        {(() => {
            if (mode === 'less') {
                return <LessMode
                    item={item}
                    onChange={onChange}
                    onDel={onDel}
                    onDup={onDup}
                    onChangeMode={() => setMode('more')}
                />
            } else {
                return <MoreMode
                    item={item}
                    onChange={onChange}
                    onDel={onDel}
                    onDup={onDup}
                    onChangeMode={() => setMode('less')}
                />
            }
        })()}
        <span>
            <OverlayTrigger
                placement='bottom'
                overlay={showCmds}
                show={show}
                trigger='click'
                rootClose
                onToggle={setShow}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                </svg>
            </OverlayTrigger>
        </span>
    </div>);
}

function LessMode({item, onDel, onDup, onChange, onChangeMode}: {
    item: item,
    onChange: (item: item) => void,
    onDel: () => void,
    onDup: () => void,
    onChangeMode: () => void,
}) {
    return (
    <div style={{display: 'flex'}}>
        <span style={{flex: 1}}>{item.product.name}</span>
        <NumberInput className={css.qty} placeholder='數量'
            value={item.classQty}
            onChange={classQty => onChange({...item, classQty})}
        />
        <div className={css.mode}>
            <Down width={14} height={14} onClick={onChangeMode}/>
        </div>
    </div>);
}

function MoreMode({item, onDel, onDup, onChange, onChangeMode}: {
    item: item,
    onChange: (item: item) => void,
    onDel: () => void,
    onDup: () => void,
    onChangeMode: () => void,
}) {
    return (
    <div>
        <div style={{display: 'flex'}}>
            <span className='product'>{item.product.name}</span>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{flex: 1}}/>
            <NumberInput className={css.qty} placeholder='數量'
                value={item.classQty}
                onChange={classQty => onChange({...item, classQty})}
            />
            ×
            <NumberInput className={css.classCnt} placeholder=''
                value={item.classCnt}
                onChange={classCnt => onChange({...item, classCnt})}
            />
            班&nbsp;&nbsp;
            <Form.Control type='text' className={css.memo} placeholder='備註'
                value={item.memo || ''}
                onChange={e => onChange({...item, memo: e.target.value})}
            />
            {(() => {
                if (canLessMode(item)) {
                    return (
                    <div className={css.mode}>
                        <Up width={14} height={14} onClick={onChangeMode}/>
                    </div>);
                } else {
                    return (
                    <div className={css.mode}>
                        <Up width={14} height={14} color='white' onClick={() => {}}/>
                    </div>);
                }
            })()}
        </div>
    </div>);
}

function NumberInput({value, className, placeholder, onChange}: {
    value: number,
    className: string,
    placeholder: string,
    onChange: (value: number) => void,
}) {
    return <Form.Control type='text' className={className} placeholder={placeholder}
        style={{textAlign: 'right'}}
        value={value || ''} required
        onChange={e => {
            const val = e.target.value;
            if (val.match(/^\d+$/)) {
                onChange(parseInt(val));
            } else {
                onChange(0);
            }
        }}
        // onFocus={e => e.target.setSelectionRange(0, e.target.value.length)}
    />;
}

function canLessMode(item: item) {
    const memo = item.memo?.trim() || ''
    return item.classCnt === 1 && memo === '';
}

type item = {
    product: {
        code: string,
        name: string,
    }
    classQty: number,       // 每班訂購數量
    classCnt: number,
    memo: string | null,
}
